exports.USERS_BATCH_SIZE = 999;
exports.SERVICE_PRINCIPALS_BATCH_SIZE = 999;
exports.AUDIT_LOGS_BATCH_SIZE = 1000;

exports.FILTERED_ROLES = new Set([
    'a0b1b346-4d3e-4e8b-98f8-753987be4970',
    '10dae51f-b6af-4016-8d66-8c2a99b929b3',
    '2af84b1e-32c8-42b7-82bc-daa82404023b'
]);

exports.AZURE_PERMISSIONS = {
    DIRECTORY: 'Directory.Read.All',
    USERS: 'User.Read.All',
    SERVICE_PRINCIPALS: 'Application.Read.All',
    ROLE_MANAGEMENT: 'RoleManagement.Read.Directory',
    AUDIT_LOGS: 'AuditLog.Read.All',
    APPLICATIONS_MANAGEMENT: 'Application.ReadWrite.OwnedBy'
};
